export default function Spacer({ height }) {
    return (
        <div style={{ height }} />
    )
}